/**
 * Opens the Report dialog (Console v2 §3.3): two steps of radio lists
 * (`REPORT_CATEGORIES`), an optional note, "Also block" for a user, then
 * "Thanks for telling us. Our Safety team will review it." Called from the
 * message menu, the profile card's menu and Message Requests; the dialog
 * itself is `ReportHost` (report/ReportDialog.tsx), mounted with the shell's
 * staff notices. Reports go to Neosocial's Safety team only (decision 8).
 */
import type { Message, Snowflake, User } from '@neosocial/protocol';
import { create } from 'zustand';

export type ReportTarget =
  | { kind: 'message'; message: Message }
  | { kind: 'user'; user: User; guildId?: Snowflake | null }
  | { kind: 'guild'; guildId: Snowflake };

export const useReport = create<{ target: ReportTarget | null; seq: number }>(() => ({
  target: null,
  seq: 0,
}));

export function openReport(target: ReportTarget): void {
  useReport.setState((s) => ({ target, seq: s.seq + 1 }));
}

export function closeReport(): void {
  useReport.setState({ target: null });
}
